!function(root, app, overwatch){

    var util = overwatch.util;

    var particle_opts = {
        "particles": {
            "number": {
                "value": 25,
                "density": {
                    "enable": true,
                    "value_area": 800
                }
            },
            "color": {
                "value": "#fff"
            },
            "shape": {
                "type": "image",
                "stroke": {
                    "width": 0,
                    "color": "#000000"
                },
                "polygon": {
                    "nb_sides": 5
                },
                "image": {
                    "src": root.messages.img.dva,
                    "width": 285,
                    "height": 298
                }
            },
            "opacity": {
                "value": 0.5,
                "random": true,
                "anim": {
                    "enable": true,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                }
            },
            "size": {
                "value": 50,
                "random": true,
                "anim": {
                    "enable": false,
                    "speed": 40,
                    "size_min": 0.1,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": false,
                "distance": 100,
                "color": "#ffffff",
                "opacity": 0.4,
                "width": 2
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "bottom",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": false,
                    "mode": "bubble"
                },
                "onclick": {
                    "enable": false,
                    "mode": "repulse"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 0.5
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 4,
                    "duration": 0.3,
                    "opacity": 1,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200,
                    "duration": 0.4
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true
    };

    function init(){

        var keys = [];
        var konami = '38,38,40,40,37,39,37,39,66,65';
        var $doc = $(root.document);
        var $body = $('body');

        $doc.on('keydown', function(event){

            keys.push(event.keyCode);

            if(keys.toString().indexOf(konami) >= 0){

                $body.addClass('konami');
                $doc.off('keydown', arguments.callee);
                $doc.trigger('konami');

            }

        });

        $doc.one('konami', function(){
            if(!util.mobile() && !util.touch() && util.width() > 768){
                $body.append('<div class="egg" id="egg-particles">');
                particlesJS('egg-particles', particle_opts);
                new Audio(root.clientVars.codeFile).play();
            }
        });

    };

    init();

}(this, this.app, this.overwatch);
